import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function SetupBranchVi() {
  return (
    <>
      <P>
        Truy cập romi.io.vn/url-nha-hang (thay “url-nha-hang” bằng Tên URL thực tế) và đăng nhập, hoặc đăng nhập rồi đi tới nhà hàng qua{' '}
        <L k="nav.myRestaurants" />. Ấn vào chi nhánh để tới trang chi nhánh, rồi ấn <L k="landing.manageBranch" />.
      </P>
      <P>
        Có 6 trang cài đặt chi nhánh: <L k="nav.branchSettings" />, <L k="nav.branchMenu" />, <L k="nav.statistics" />, <L k="nav.staff" />,{' '}
        <L k="nav.tables" /> và <L k="nav.branchInfo" />.
      </P>
      <Note>
        Tài khoản <L k="role.manager" /> và <L k="role.superuser" /> thấy đủ 6; <L k="role.admin" /> chỉ thấy 5 (không có <L k="nav.branchInfo" />).
      </Note>
      <H2>Cài đặt chi nhánh</H2>
      <Ul>
        <li>
          <L k="branchSettings.openShop" /> / <L k="branchSettings.closeShop" />: đóng cửa sẽ không nhận thêm đơn của khách; mở cửa khi bắt đầu ngày làm việc.
        </li>
        <li>
          <L k="branchSettings.mode" />: <L k="branchSettings.mode.open" />; <L k="branchSettings.mode.login" />; <L k="branchSettings.mode.closed" />, chỉ
          nhân viên tạo đơn được. Khách quét QR ở chế độ đóng sẽ thấy thông báo và được dẫn sang trang chi nhánh.
        </li>
        <li>
          Chế độ mở có thêm <L k="branchSettings.expiry" />: đơn của khách ở trạng thái <L k="track.status.sent" /> và tự hết hạn sau số phút này nếu nhân
          viên không chuyển sang <L k="track.status.confirmed" />. Mặc định 10.
        </li>
        <li>
          Chế độ đăng nhập có thêm <L k="branchSettings.cap" />: mỗi tài khoản chỉ được giữ tối đa bấy nhiêu đơn đang hoạt động (
          <L k="track.status.confirmed" />, <L k="track.status.processing" /> hoặc <L k="track.status.ready" />) cùng lúc. Mặc định 2.
        </li>
        <li>
          <L k="branchSettings.pinGate" />: mỗi đơn phải nhập mã PIN trước khi gửi, để chỉ khách đang có mặt tại quán mới đặt được. Nhân viên xem mã PIN hiện
          tại ở đầu trang <L k="nav.queue" />. Nhớ đổi mã thường xuyên.
        </li>
        <li>
          <L k="branchSettings.deliveryAddress" />: thêm ô nhập tự do cho đơn mang đi để ghi địa chỉ giao hàng hoặc số bàn. Dùng khi chi nhánh không quản lý
          phiên bàn và các đơn cùng bàn đều tính tiền riêng.
        </li>
      </Ul>
      <H2>Thực đơn chi nhánh</H2>
      <P>
        Hiển thị thực đơn của nhà hàng (đã tạo tại trang <L k="nav.menu" /> của nhà hàng). Mỗi chi nhánh chỉ chỉnh được ba mục cho từng món:
      </P>
      <Ul>
        <li>
          <L k="branchMenu.price" />: giá riêng của chi nhánh (ví dụ: cửa hàng tại trung tâm thương mại lớn cần tăng giá để bù tiền thuê mặt bằng). Để trống
          để dùng giá gốc.
        </li>
        <li>
          <L k="branchMenu.stock" />: tùy chọn, cho món có số lượng giới hạn hàng ngày. Khi về 0, món hiện là hết hàng và không đặt được.
        </li>
        <li>
          <L k="branchMenu.available" />: bỏ chọn khi hết hàng hoặc không bán tại chi nhánh.
        </li>
      </Ul>
      <H2>Thống kê</H2>
      <P>Hiển thị số liệu của chi nhánh.</P>
      <H2>Nhân viên</H2>
      <P>
        Quản lý các tài khoản nhân viên của chi nhánh. Tìm theo đúng số điện thoại hoặc email của tài khoản Romi đã đăng ký và ấn <L k="staff.add" />.
      </P>
      <H2>Bàn</H2>
      <Ul>
        <li>Chỉ cần dùng khi quản lý phiên bàn, tức mỗi bàn có thể đặt món nhiều lần (nhiều đơn) và khi tính tiền sẽ tính chung tất cả đơn đã đặt.</li>
        <li>
          Nếu mỗi đơn được thanh toán riêng thì không cần tạo bàn. Cân nhắc dùng QR mang đi và bật <L k="branchSettings.deliveryAddress" /> để khách nhập bàn
          đang ngồi.
        </li>
      </Ul>
      <P>
        Các nút QR tại đây hiển thị mã QR cho từng mục: <L k="tables.printQr.restaurant" />, <L k="tables.printQr.branch" />, <L k="tables.printQr.take_away" />
        , và mỗi bàn một nút <L k="tables.print" /> cho đơn dùng tại bàn. Tính năng in được tích hợp sẵn.
      </P>
      <H2>Thông tin chi nhánh</H2>
      <P>Tên chi nhánh, địa chỉ, số điện thoại, giờ mở cửa và thông báo. Hiển thị trên trang công khai của chi nhánh và in ở đầu phiếu.</P>
      <Note>
        Khi có nhân viên nghỉ việc, ấn <L k="staff.remove" /> ở trang nhân viên của chi nhánh, hoặc gỡ vai trò ở trang tài khoản của nhà hàng, để họ không
        còn truy cập quản lý hay vận hành chi nhánh. Chỉ <L k="role.admin" /> trở lên mới cài đặt được chi nhánh; chỉ <L k="role.manager" /> và{' '}
        <L k="role.superuser" /> mới đổi được những mục thuộc quyền quản lý chung như giá riêng của chi nhánh.
      </Note>
      <P>Nhà hàng của bạn đã sẵn sàng hoạt động. Xem hướng dẫn vận hành để biết chi nhánh hoạt động hằng ngày thế nào.</P>
    </>
  )
}
